import { creatorbase } from '@round/api';
import ActionButton from '../ActionButton/ActionButton';
import { useNavigate } from 'react-router-dom';
import styles from './CreatorbaseProject.module.css';
import React from 'react';
import { ReactComponent as LinkIcon } from 'assets/icons/Share.svg';
import cn from 'classnames';
import { PopoverOnOverflow } from '@round/ui-kit';

type Props = {
    project: creatorbase.Project | null;
    brand: creatorbase.Brand | null;
    team: creatorbase.Team | null;
    /*
     * We're passing project url separately instead of building it inside a component
     * because creatorbase_round_planners can retrieve a project ignoring team access.
     * That way we still display linked project data but don't let them visit a page
     * they don't have access to.
     * Project url should be fetched separately without ignoring team access.
     * It's probably going to change in the future when linking projects will be allowed for all staff.
     * */
    projectUrl: string | null;
};

const CreatorbaseProject = ({ project, brand, team, projectUrl }: Props) => {
    const navigate = useNavigate();

    return (
        <ActionButton
            className={cn(styles.button, { [styles.linkActive]: !!projectUrl })}
            onClick={() => {
                if (projectUrl) {
                    navigate(projectUrl);
                }
            }}
        >
            <div className={cn(styles.container, { [styles.linkActive]: !!projectUrl })}>
                <LinkIcon className={styles.actionButtonIcon} />
                <div className={styles.copy}>
                    <PopoverOnOverflow
                        isDisabled={!!projectUrl}
                        popoverContent={<div className={styles.popoverContent}>{project?.name}</div>}
                    >
                        {(ref) => <p ref={ref}>{project?.name}</p>}
                    </PopoverOnOverflow>
                    <div className={styles.subTitle}>
                        <PopoverOnOverflow
                            isDisabled={!!projectUrl}
                            popoverContent={
                                <div className={styles.popoverContent}>
                                    {brand?.name} | {team?.name}
                                </div>
                            }
                        >
                            {(ref) => (
                                <p ref={ref} className={styles.brandInfo}>
                                    {brand?.name} | {team?.name}
                                </p>
                            )}
                        </PopoverOnOverflow>
                        <p className={styles.navigationLabel}>View on Creatorbase</p>
                    </div>
                </div>
            </div>
        </ActionButton>
    );
};

export default CreatorbaseProject;
